
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { GetSubscriptionsRequest } from './types';
import {
  QueueSubscriptionRequest,
  QueueSubscriptionResponse,
  SubscriptionsConfigResponse,
} from '../entities/subscription-config-v1/models';
import { axiosInstance } from "../axios-instance";

class SubscriptionConfig {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getSubscriptions(
    input: GetSubscriptionsRequest,
  ): Promise<AxiosResponse<SubscriptionsConfigResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<SubscriptionsConfigResponse>(`${this.baseUrl}/subscriptions`, {
      params: input,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  queueSubscriptions(input: QueueSubscriptionRequest)
  : Promise<AxiosResponse<QueueSubscriptionResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<QueueSubscriptionResponse>(
      `${this.baseUrl}/queueConfigs`,
      input,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
}

export default SubscriptionConfig;
